import { Link, useLocation } from 'react-router-dom';

import * as Styles from './styles';
import { useAuth } from '../../context/Auth/useAuth';

export const Superior = () => {
  const location = useLocation();
  const auth = useAuth();

  return (
    <>
      <Styles.NavSuperior className="navbar p-2 navbar-expand-lg bg-body-tertiary sticky-top">
        <div className="container-fluid">
          <img src="./logo512.png" alt="" style={{ width: '2rem', marginRight: '0.4rem' }} />
          <Link to={`/`} className="navbar-brand">
            Monitor Logistico
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
            {auth.token && (
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link
                    to={`/token`}
                    className={`nav-link ${location.pathname == '/token' ? 'active' : ''}`}
                    aria-current="page"
                  >
                    Tokens
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/cargas`} className={`nav-link ${location.pathname == '/cargas' ? 'active' : ''}`}>
                    Cargas
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/canhotos`} className={`nav-link ${location.pathname == '/canhoto' ? 'active' : ''}`}>
                    Canhotos
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/config`} className={`nav-link ${location.pathname == '/canhoto' ? 'active' : ''}`}>
                    Configurar
                  </Link>
                </li>

                <li className="nav-item">
                  <button
                    type="button"
                    className="nav-link"
                    data-bs-toggle="modal"
                    data-bs-target={`#sairPlataformaCanhoto`}
                  >
                    Sair
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </Styles.NavSuperior>
      <div
        className="modal fade"
        id={`sairPlataformaCanhoto`}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Canhoto Digital
              </h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Tem certeza que deseja sair?</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={() => auth.logout()}>
                Sair
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
